import { FormControlLabel } from "@mui/material";
import ThemeSwitch from "../ThemeSwitch";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import React from "react";

interface SameAsAboveProps {
  values: any;
  setFieldValue: any;
  switchChange: any;
  screen?: string | undefined;
}

const SameAsAbove = (props: SameAsAboveProps) => {
  const { values, setFieldValue, switchChange, screen } = props;
  const whatsAppMobileNumber =
    values?.whatsappMobileNumber || values?.whatsAppMobileNumber || "";
  const primaryMobileNumber =
    values?.mobileNumber || values?.primaryMobileNumber || "";
  const { t } = useTranslation();
  const [sameAsAbove, setSameAsAbove] = useState<any>(
    whatsAppMobileNumber === primaryMobileNumber
  );

  React.useEffect(() => {
    if (screen === "franchiseMasterHo") {
      if (whatsAppMobileNumber === primaryMobileNumber) {
        setSameAsAbove(true);
      } else {
        setSameAsAbove(false);
      }
    }
  }, [values]);

  const handleSwitchChange = (value: boolean, setFieldValue?: any) => {
    if (setFieldValue) {
      if (value) {
        setSameAsAbove(value);
        setFieldValue("whatsappMobileNumber", values?.primaryMobileNumber);
      } else {
        setFieldValue("whatsappMobileNumber", "");
        setSameAsAbove(false);
      }
    } else {
      setSameAsAbove(value);
    }

    switchChange(value);
  };

  return (
    <FormControlLabel
      sx={{ height: "32px" }}
      value={true}
      control={
        <ThemeSwitch
          checked={sameAsAbove}
          onChange={(e: any) => {
            setFieldValue("whatsappMobileNumber", values.primaryMobileNumber);
            handleSwitchChange(e.target.checked, setFieldValue);
          }}
        />
      }
      label={<label>{t("sameasabove")}</label>}
      labelPlacement="start"
    />
  );
};
export default SameAsAbove;
